module.exports = __webpack_public_path__ + "static/img/11@2x.e593ad24.png";